import React, { Component } from "react";
import { Button, Col, Form, Icon, Row, Collapse } from "antd";

import TemplateFields from "./Helpers/TemplateFields";

import { urlPath } from "../Settings";
import { getAuthHeader } from '../../utils/security';

const { Panel } = Collapse;

class NativeTemplateForm extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    const {
      selectedTemplate,
      templateFields,
      form,
      onCancel,
      childConfig,
      native,
      internal
    } = this.props;

    this.state = {
      selectedTemplate,
      templateFields,
      form,
      onCancel,
      childConfig
    };
  }

  updateTemplateValues = (body, admaterial) => {
    const { onCancel } = this.state;
    const { specId } = this.props;
    const url =
      `${urlPath}/api/adservers/templates?admaterial=${admaterial}` +
      "&matspec=" +
      specId;
    return fetch(url, {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json; charset=utf-8", ...getAuthHeader() },
      body
    })
      .then(response => response.json())
      .then(result => {
        const { status } = result;

        return status === "ok" ? onCancel() : false;
      })
      .catch(err => console.log(err));
  };

  handleSubmit = e => {
    e.preventDefault();
    const { selectedTemplate, childConfig } = this.state;
    const { form, templateFields, admaterial } = this.props;
    const { id, fields } = templateFields;
    const { updateSelectedTemplateText } = childConfig;
    const { value: templateId, key: templateName } = selectedTemplate;

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const body = { ixTemplateId: id, ixTemplateName: ((this.props.native && !this.props.internal) ? "Native - All" : templateName) };
        Object.keys(values).forEach(key => {
          if (values[key]) {
            const uniqueName = fields.find(field => field.uniqueName === key);
            const { type } = uniqueName;
            if (type === "Long") {
              body[key] = {
                [type]: parseInt(values[key])
              };
            } else {
              body[key] = {
                [type]: values[key]
              };
            }
          }
        });
        updateSelectedTemplateText(templateId, templateName);
        let ret = this.updateTemplateValues(JSON.stringify(body), admaterial)
        console.log("ret: " + ret);
        if (ret)
          setTimeout(() => {
            window.location.reload();
          }, 500);
      }
    });
  };

  componentDidUpdate = prevProps => {
    if (this.props !== prevProps) {
      this.setState({ ...this.props });
    }
  };

  render() {
    const {
      selectedTemplate,
      templateFields,
      form,
      onCancel,
      childConfig
    } = this.state;

    const { fields, snippet } = templateFields;

    const preStyles = {
      whiteSpace: "pre-wrap",
      textAlign: "left",
      background: "#ececec",
      padding: "20px",
      margin: "20px 0",
      fontSize: "12px"
    };

    const collapseStyle = {
      border: "none",
      background: "none",
      textAlign: "left"
    };

    const panelStyle = {
      background: "#f7f7f7",
      borderRadius: 4,
      marginBottom: 24,
      border: 0,
      overflow: "hidden"
    };

    return selectedTemplate && templateFields ? (
      <Form layout="vertical" onSubmit={this.handleSubmit}>
        <Row>
          <Col span={24} style={{ padding: "0 10px" }}>
            <Row>
              <Col>
                <h4>{selectedTemplate.key}</h4>
              </Col>
            </Row>
            <Row>
              <Col>
                <TemplateFields
                  fields={fields}
                  form={form}
                  childConfig={childConfig}
                />
              </Col>
            </Row>
            {/* <Row style={{ margin: "0 0 20px 0" }}>
              <Collapse
                expandIcon={({ isActive }) => (
                  <Icon type="caret-right" rotate={isActive ? 90 : 0} />
                )}
                style={collapseStyle}
              >
                <Panel header="Preview Snippet" key="1" style={panelStyle}>
                  <pre style={preStyles}>{`${snippet}`}</pre>
                </Panel>
              </Collapse>
            </Row> */}
            <Row type="flex" justify="end">
              <Col span={10}>
                <Button
                  className="login-form-button"
                  style={{ margin: "0 10px 0" }}
                  onClick={onCancel}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                >
                  Send
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    ) : null;
  }
}

const WrappedNativeTemplateForm = Form.create({ name: "native_templates" })(
  NativeTemplateForm
);

export default WrappedNativeTemplateForm;



// WEBPACK FOOTER //
// ./src/components/NativeTemplates/NativeTemplateForm.js